import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';

import {
  ReduceToClearListContent,
  ReduceToClearSearchCriteria,
  ReduceToClearViewResponse
} from '../../model/reduce-to-clear.model';

export const ReduceToClearAction = createActionGroup({
  source: 'Reduce To Clear List',
  events: {
    RequestList: props<{ criteriaObj: ReduceToClearSearchCriteria }>(),
    ResponseList: props<{
      data: Pagination<ReduceToClearListContent>;
    }>()
  }
});

export const ReduceToClearViewAction = createActionGroup({
  source: 'Reduce To Clear View',
  events: {
    Request: props<{ docNo: string }>(),
    Response: props<{ data: ReduceToClearViewResponse }>(),
    ResetView: emptyProps()
  }
});
